// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"Header_headerWrap__3IMB2","details":"Header_details__NaeFM","detailsBtn":"Header_detailsBtn__2hpsE","closeBtn":"Header_closeBtn__2flL3"};